import { Header, Segment } from 'semantic-ui-react';
import { ImpactType } from '../../../../types';
import ImpactTable from './components/impactTable';
import { useImportTableStoreDescriptorsMap } from '../../context/importTableContext';

type ImpactTablePropsType = {
    impact: ImpactType;
};

const ImportImpact = ({ impact }: ImpactTablePropsType) => {
    const descriptorsMap = useImportTableStoreDescriptorsMap();

    return (
        <Segment>
            <Header>New Fields</Header>
            <Segment>
                {!!impact.addedDescriptors.length ? (
                    <>
                        {impact.addedDescriptors.map((descriptorId) => {
                            return (
                                <p key={descriptorId}>{descriptorsMap[impact.descriptorToRow[descriptorId]].label}</p>
                            );
                        })}
                    </>
                ) : (
                    <p>No new fields</p>
                )}
            </Segment>
            <Header>New Reports</Header>
            <Segment>
                {!!impact.addedReports.length ? (
                    <>
                        {impact.addedReports.map((x, i) => {
                            return <p key={i}>{x}</p>;
                        })}
                    </>
                ) : (
                    <p>No new reports</p>
                )}
            </Segment>
            <Header>Updated Reports</Header>
            <Segment className="overflow--auto">
                {!!impact.updatedReports.length ? <ImpactTable impact={impact} /> : <p>No updated reports</p>}
            </Segment>
        </Segment>
    );
};

export default ImportImpact;
